/* pp-note-panel.js — PPP
 * Le panneau « autres parfums avec cette note » de la fiche produit.
 *
 * Un clic sur une note de la pyramide ([data-pp-note]) ouvre le <dialog>
 * [data-pp-note-panel] de la même section et y liste les parfums qui
 * contiennent la même famille de note.
 *
 * LES DONNÉES viennent de l'index templates/collection.pp-notes.liquid, dans
 * la langue et la devise du visiteur. Chargé une fois, au premier signe
 * d'intention (survol, focus ou toucher d'une note), puis gardé en mémoire de
 * session 30 minutes : naviguer de fiche en fiche ne le recharge pas.
 *
 * Tout le texte venu des données passe par textContent, jamais par innerHTML.
 */
(function () {
  'use strict';

  var TTL = 30 * 60 * 1000;
  var MAX_PAGES = 20;                 // 20 × 250 parfums : bien au-delà du catalogue
  var TIER_ORDER = 'tcf';
  var memo = {};

  // --- Index -----------------------------------------------------------------
  function cacheKey(base) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    return 'ppn:v2:' + cur + ':' + base;
  }
  function readCache(key) {
    try {
      var o = JSON.parse(sessionStorage.getItem(key) || 'null');
      return o && Date.now() - o.at < TTL ? o.items : null;
    } catch (e) { return null; }
  }
  function writeCache(key, items) {
    try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), items: items })); } catch (e) {}
  }
  function pageUrl(base, n) {
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'page=' + n;
  }
  function fetchPage(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }
  function loadIndex(base) {
    var key = cacheKey(base);
    if (memo[key]) return memo[key];
    var cached = readCache(key);
    if (cached) return (memo[key] = Promise.resolve(cached));
    memo[key] = fetchPage(pageUrl(base, 1))
      .then(function (first) {
        var items = first.items || [];
        var pages = Math.min(first.pages || 1, MAX_PAGES);
        if (pages <= 1) return items;
        var rest = [];
        for (var p = 2; p <= pages; p++) rest.push(fetchPage(pageUrl(base, p)));
        return Promise.all(rest).then(function (all) {
          all.forEach(function (d) { items = items.concat(d.items || []); });
          return items;
        });
      })
      .then(function (items) { writeCache(key, items); return items; })
      .catch(function (err) { delete memo[key]; throw err; });
    return memo[key];
  }

  // Parfums portant la famille `key`, hors parfum courant. Trois groupes :
  // flacon de référence disponible, flacon épuisé mais d'autres formats en
  // vente, parfum entièrement épuisé. Dans chaque groupe, l'ordre des
  // meilleures ventes, qui est celui de l'index.
  function matches(items, key, current) {
    var dispo = [], partiels = [], epuises = [];
    items.forEach(function (it) {
      if (it.h === current) return;
      var tiers = [], variants = [];
      (it.n || []).forEach(function (n) {
        if (n[0] !== key) return;
        if (tiers.indexOf(n[1]) < 0) tiers.push(n[1]);
        if (n[2] && variants.indexOf(n[2]) < 0) variants.push(n[2]);
      });
      if (!tiers.length) return;
      tiers.sort(function (a, b) { return TIER_ORDER.indexOf(a) - TIER_ORDER.indexOf(b); });
      (it.x ? epuises : it.o ? partiels : dispo).push({ it: it, tiers: tiers, variants: variants });
    });
    return dispo.concat(partiels, epuises);
  }

  // --- DOM ------------------------------------------------------------------
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function card(m, T) {
    var li = el('li', 'ppn__row');
    var a = el('a', 'ppn__item');
    a.href = m.it.u;

    var thumb = el('span', 'ppn__thumb');
    if (m.it.i) {
      var img = el('img');
      img.src = m.it.i;
      img.alt = '';
      img.width = 80;
      img.height = 80;
      img.loading = 'lazy';
      img.decoding = 'async';
      thumb.appendChild(img);
    }

    var meta = el('span', 'ppn__meta');
    meta.appendChild(el('span', 'ppn__vendor', m.it.v));
    meta.appendChild(el('span', 'ppn__name', m.it.t));
    var where = m.tiers.map(function (t) { return T.tiers[t]; }).join(' · ');
    if (m.variants.length) where += ' · ' + m.variants.join(', ');
    meta.appendChild(el('span', 'ppn__where', where));
    var price = el('span', 'ppn__price' + (m.it.o ? ' is-out' : ''));
    price.appendChild(el('span', 'ppn__amount', m.it.p));
    if (m.it.o) {
      var reste = !m.it.x && m.it.f;
      price.appendChild(el('span', 'ppn__out', reste ? (T.avail || '{f}').replace('{f}', m.it.f) : T.out));
    }
    meta.appendChild(price);

    a.appendChild(thumb);
    a.appendChild(meta);
    li.appendChild(a);
    return li;
  }

  function setup(dialog) {
    if (dialog.__ppn) return dialog.__ppn;
    var T = {};
    try { T = JSON.parse(dialog.querySelector('[data-ppn-i18n]').textContent); } catch (e) {}
    T.tiers = T.tiers || { t: '', c: '', f: '' };

    var base = dialog.getAttribute('data-index-url');
    var current = dialog.getAttribute('data-current');
    var titleEl = dialog.querySelector('[data-ppn-title]');
    var countEl = dialog.querySelector('[data-ppn-count]');
    var body = dialog.querySelector('[data-ppn-body]');
    var icon = dialog.querySelector('[data-ppn-img]');
    var root = dialog.closest('[data-pp-product]');
    var fallback = root && root.getAttribute('data-note-fallback');
    var opener = null;
    var shownKey = null;

    icon.addEventListener('error', function () {
      if (fallback && icon.src.indexOf(fallback) !== 0) icon.src = fallback + '?width=112';
      else icon.hidden = true;
    });

    function state(cls, text) {
      body.textContent = '';
      body.setAttribute('aria-busy', cls === 'is-loading' ? 'true' : 'false');
      var box = el('div', 'ppn__state ' + cls);
      box.appendChild(el('p', 'ppn__msg', text));
      body.appendChild(box);
      return box;
    }

    function loading() {
      var box = state('is-loading', T.loading);
      var sk = el('ul', 'ppn__skeleton');
      sk.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 4; i++) sk.appendChild(el('li'));
      box.appendChild(sk);
    }

    function show(key) {
      loading();
      loadIndex(base).then(function (items) {
        if (shownKey !== key) return;
        var list = matches(items, key, current);
        body.setAttribute('aria-busy', 'false');
        if (!list.length) {
          countEl.textContent = '';
          state('is-empty', T.empty);
          return;
        }
        countEl.textContent = (list.length === 1 ? T.one : T.other).replace('{n}', list.length);
        body.textContent = '';
        var ul = el('ul', 'ppn__list');
        list.forEach(function (m) { ul.appendChild(card(m, T)); });
        body.appendChild(ul);
        body.scrollTop = 0;
      }).catch(function () {
        if (shownKey !== key) return;
        var box = state('is-error', T.error);
        var retry = el('button', 'ppn__retry', T.retry);
        retry.type = 'button';
        retry.addEventListener('click', function () { show(key); });
        box.appendChild(retry);
        retry.focus();
      });
    }

    function open(trigger) {
      var key = trigger.getAttribute('data-pp-note');
      if (!key) return;
      opener = trigger;
      shownKey = key;
      titleEl.textContent = trigger.getAttribute('data-pp-note-label') || trigger.textContent.trim();
      countEl.textContent = '';
      var src = trigger.getAttribute('data-pp-note-img');
      if (src) { icon.hidden = false; icon.src = src; } else { icon.hidden = true; }
      show(key);
      if (!dialog.open) {
        dialog.showModal();
        document.documentElement.classList.add('ppn-lock');
      }
      // Le focus va au titre, pas au bouton de fermeture que showModal()
      // choisirait : un lecteur d'écran annonce la note, et un clic de souris
      // n'allume pas d'anneau sur la croix. Tab mène ensuite à la croix.
      titleEl.focus({ preventScroll: true });
    }

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('ppn-lock');
      shownKey = null;
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    });
    dialog.querySelector('[data-ppn-close]').addEventListener('click', function () { dialog.close(); });
    // Le <dialog> n'a ni marge ni padding : un clic dont la cible est le
    // dialog lui-même est un clic sur le voile.
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

    dialog.__ppn = { open: open, prefetch: function () { loadIndex(base).catch(function () {}); } };
    return dialog.__ppn;
  }

  function panelFor(trigger) {
    var root = trigger.closest('[data-pp-product]');
    var dialog = root && root.querySelector('[data-pp-note-panel]');
    return dialog && typeof dialog.showModal === 'function' ? setup(dialog) : null;
  }

  // --- Délégation : survit aux re-rendus de section dans l'éditeur de thème ---
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-pp-note]');
    if (!trigger) return;
    var panel = panelFor(trigger);
    if (!panel) return;
    e.preventDefault();
    panel.open(trigger);
  });

  function intent(e) {
    var trigger = e.target.closest && e.target.closest('[data-pp-note]');
    if (!trigger) return;
    var panel = panelFor(trigger);
    if (panel) panel.prefetch();
  }
  document.addEventListener('pointerover', intent, { passive: true });
  document.addEventListener('focusin', intent);
  document.addEventListener('touchstart', intent, { passive: true });

  // La phrase d'aide n'apparaît que si ce script tourne : sans lui, les notes
  // ne s'ouvrent pas, et la phrase promettrait un geste qui ne fait rien.
  function reveal(scope) {
    (scope || document).querySelectorAll('[data-ppn-hint]').forEach(function (h) { h.hidden = false; });
  }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
  reveal(document);
})();
